import { useEffect } from "react";
import "./Informacoes.css";

import icon1 from '../../img/icon_email.svg';
import icon2 from '../../img/icon_insta.svg';
import icon3 from '../../img/icon_local.svg';
import icon4 from '../../img/icon_redes.svg';
import icon5 from '../../img/icon_tel.svg';
import icon6 from '../../img/icon_wpp.svg';



function Informacoes() {

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("fade-in");
                }
            });
        }, { threshold: 0.1 });

        // Incluímos o título, os cartões de informação e o contêiner do iframe
        document.querySelectorAll(".title, .card-i, .card-i img, .card-mapa").forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);



    return (
        <div className="container-inicial container-informacoes" id="informacoes">
            <h1 className="title">Contatos</h1>
            <meta name="description" content="Entre em contato com a Blue Análises e Serviços Ambientais em Juiz de Fora. Veja telefone, e-mail, endereço e localização no mapa." />

            <div className="informacoes-mapa">
                <div className="card-info">
                    <div className="card-i">
                        <div>
                            <img src={icon5} alt="Ícone de telefone" loading="lazy" />
                        </div>
                        <div className="desc-info">
                            <h6 className="tipo-info">Telefone</h6>
                            <p className="desc-info">
                                <a href="tel:03233210063" type="tel">32 3321-0063</a>
                            </p>
                        </div>
                    </div>

                    <div className="card-i">
                        <div>
                            <img src={icon1} alt="Ícone de e-mail" loading="lazy" />
                        </div>
                        <div className="desc-info">
                            <h6 className="tipo-info">E-mail</h6>
                            <p className="desc-info">
                                <a href="mailto:comercial@blueanalises.com.br" type="email">comercial@blueanalises.com.br</a>
                            </p>
                        </div>
                    </div>

                    <div className="card-i">
                        <div>
                            <img src={icon3} alt="Ícone de endereço" loading="lazy" />
                        </div>
                        <div className="desc-info">
                            <h6 className="tipo-info">Endereço</h6>
                            <p className="desc-info">Av. Brasil, 998 - Costa Carvalho, Juiz de Fora - MG</p>
                        </div>
                    </div>

                    <div className="card-i d-none">
                        <div>
                            <img src={icon4} alt="Ícone ilustrativo de redes sociais" loading="lazy" />
                        </div>
                        <h6 className="tipo-info">Redes</h6>
                        <div className="desc-info">
                            <a href="#" target="_blank" rel="noopener noreferrer" className="link-rede">
                                <img src={icon2} alt="Ícone do Facebook" loading="lazy" />
                            </a>
                            <a href="#" target="_blank" rel="noopener noreferrer" className="link-rede">
                                <img src={icon6} alt="Ícone do Instagram" loading="lazy" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="card-mapa">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3705.463922125707!2d-43.335322399999995!3d-21.762299!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x989db457b06a83%3A0x93f7ca6d59a835f1!2sBlue%20An%C3%A1lises%20e%20Servi%C3%A7os%20Ambientais%20Ltda!5e0!3m2!1spt-BR!2sbr!4v1748398474998!5m2!1spt-BR!2sbr"
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Mapa da Blue Análises"
                    ></iframe>
                </div>
            </div>
        </div>

    );
}

export default Informacoes;
